var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVikingHelmet(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m292.571 80.014c0-20.198-16.374-36.571-36.571-36.571s-36.571 16.374-36.571 36.571v215.922h73.143v-215.922z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.652 229.682c40.506-26.015 67.348-71.461 67.348-123.18 0-33.261-11.105-63.919-29.802-88.487l-9.55 2.939c-3.94 84.795-44.483 109.337-92.427 114.518 29.856 24.145 52.565 56.787 64.431 94.21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m88.143 295.935h101.285v-160.643c-59.533 25.82-101.285 85.155-101.285 154.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m322.571 135.281v160.654h101.286v-6.572c0-68.917-41.751-128.261-101.286-154.082z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.571 457.414v-28.336h-73.142v28.336l36.571 36.571z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m67.351 229.684c11.868-37.425 34.58-70.066 64.44-94.21-47.95-5.178-88.499-29.717-92.44-114.519l-9.55-2.939c-18.696 24.567-29.801 55.225-29.801 88.486 0 51.72 26.843 97.167 67.351 123.182z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.857 325.935h402.286v73.143h-402.286z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVikingHelmet);
export default __webpack_public_path__ + "static/media/viking-helmet.e667a778deaea4ba494e7eb35e2f859b.svg";
export { ForwardRef as ReactComponent };